import { UIModule } from '@c4/ui';
import { RoleBasedAuthorizationProvider } from './strategies/rbac-provider';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { CookieModule } from 'ngx-cookie';

import { CoreModule } from '@c4/core';
import { AssetsModule } from '@c4/assets';

import { AuthenticationComponent } from './authentication.component';
import { AuthenticationService, authenticationReducer } from './services/authentication.service';
import { AuthenticationGuard } from './services/authentication.guard';
import { Local } from './strategies/local';

import { AuthorizationService, authorizationReducer } from './services/authorization.service';
import { AuthorizationGuard } from './services/authorization.guard';
import { IdentityService, identityReducer, IdentityState } from './services/identity.service';

export const AUTH_REDUCERS = {
  authentication: authenticationReducer,
  authorization: authorizationReducer,
  identity: identityReducer
};

@NgModule({
  declarations: [
    AuthenticationComponent,
  ],
  imports: [
    AssetsModule,
    BrowserModule,
    FormsModule,
    CoreModule,
    RouterModule,
    UIModule,
    CookieModule.forRoot()
  ],
  exports: [
    AuthenticationComponent,
  ],
  providers: [
    AuthenticationService,
    AuthenticationGuard,
    AuthorizationService,
    AuthorizationGuard,
    IdentityService,
    RoleBasedAuthorizationProvider
  ]
})
export class AuthModule { }



// WEBPACK FOOTER //
// ./~/@c4/auth/src/app/app.module.ts